/* gsap-boot.js -- v21 S4 tier 3. The GSAP no-op shim + CDN loader, moved out
   of layout/theme.liquid where they were two inline <script> blocks re-parsed
   on every navigation.

   ORDERING IS THE WHOLE RISK, so it is stated here and enforced in the layout:
   this file MUST be declared with `defer` BEFORE custom.js. Defer scripts run
   in document order; custom.js gates every animation on window.__gsapReady,
   which THIS file creates. The last time this ordering was violated, custom.js
   bound to the shim and every scroll animation on the site silently died
   (documented in the shim comments below). Moving inline->asset preserves
   order only because the tag sits above custom.js's tag in theme.liquid.

   Ships alone, in its own commit and deploy, so any regression is unambiguous.
*/
      (function () {
        // GSAP no-op shim — installed unconditionally so custom.js can call
        // gsap.to / gsap.from / gsap.set / gsap.timeline / gsap.registerPlugin
        // without throwing. Replaced by real GSAP on desktop via the script
        // tag below (the real library overwrites window.gsap once loaded).
        //
        // CRITICAL: every method that returns a Tween/Timeline must return a
        // self-referencing chainable proxy, since user code uses chained calls
        // like gsap.timeline({...}).to(...).to(...). Returning undefined or a
        // plain object breaks the chain and throws "Cannot read properties of
        // undefined (reading 'to')" — which cascades into other JS errors.
        var chainable = {};
        var noop = function () { return chainable; };
        ['to','from','fromTo','set','add','addLabel','call','play','pause','restart','reverse','seek','kill','clear','progress','duration','timeScale','then','eventCallback','tweenTo','tweenFromTo','staggerTo','staggerFrom','invalidate','remove','restartTimeline'].forEach(function(m){ chainable[m] = noop; });

        var gsapShim = {
          to: noop, from: noop, fromTo: noop, set: noop,
          timeline: noop, delayedCall: noop, killTweensOf: noop,
          registerPlugin: function () {},
          getProperty: function () { return 0; },
          quickSetter: function () { return noop; },
          utils: {
            toArray: function (s) { return typeof s === 'string' ? Array.prototype.slice.call(document.querySelectorAll(s)) : (s || []); },
            wrap: function () { return 0; },
            mapRange: function () { return 0; },
            random: function () { return 0; }
          }
        };
        if (typeof window.gsap === 'undefined') window.gsap = gsapShim;
        if (typeof window.ScrollTrigger === 'undefined') window.ScrollTrigger = {
          create: function () { return chainable; },
          refresh: function () {},
          killAll: function () {},
          getAll: function () { return []; },
          update: function () {}
        };

        // __gsapReady — resolves when real GSAP + ScrollTrigger have executed
        // (desktop), or immediately on mobile where the shim IS the intended
        // implementation. custom.js gates all its gsap/ScrollTrigger calls on
        // this. Without it custom.js (parser-deferred) always beat the
        // script-inserted, force-async GSAP and bound to the shim, silently
        // killing every scroll animation site-wide.
        window.__gsapReadyResolve = function () {};
        window.__gsapReady = new Promise(function (resolve) {
          window.__gsapReadyResolve = resolve;
        });

        // In-app webview detection (Instagram, Facebook, Messenger, Threads)
        var ua = navigator.userAgent || '';
        window.__everawIsWebview = /Instagram|FBAN|FBAV|FB_IAB|FBIOS|Messenger|Threads/i.test(ua);
      })();
    

      {
        // async=false is what actually orders these. `defer` on a
        // script-CREATED element is ignored by the spec (force-async is set),
        // so without this ScrollTrigger could execute before gsap.
        var pending = 2;
        var settle = function () {
          if (--pending === 0) window.__gsapReadyResolve();
        };
        var s1 = document.createElement('script');
        s1.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.13.0/gsap.min.js';
        s1.integrity = 'sha512-NcZdtrT77bJr4STcmsGAESr06BYGE8woZdSdEgqnpyqac7sugNO+Tr4bGwGF3MsnEkGKhU2KL2xh6Ec+BqsaHA==';
        s1.crossOrigin = 'anonymous';
        s1.referrerPolicy = 'no-referrer';
        s1.async = false;
        s1.onload = s1.onerror = settle;
        document.head.appendChild(s1);
        var s2 = document.createElement('script');
        s2.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.13.0/ScrollTrigger.min.js';
        s2.integrity = 'sha512-P2IDYZfqSwjcSjX0BKeNhwRUH8zRPGlgcWl5n6gBLzdi4Y5/0O4zaXrtO4K9TZK6Hn1BenYpKowuCavNandERg==';
        s2.crossOrigin = 'anonymous';
        s2.referrerPolicy = 'no-referrer';
        s2.async = false;
        s2.onload = s2.onerror = settle;
        document.head.appendChild(s2);
        // Never let the page hang on a dead CDN: fall through to the shim.
        // Promise resolve is idempotent, so a late real load still wins.
        setTimeout(function () { window.__gsapReadyResolve(); }, 5000);
      }
    
